import { AssetReference, WIDGET_PROPERTY_PREFIX } from '@studio/domain';
import { IElementProperty } from '@studio/domain/creativeset';
import { IWidgetInstance } from './widget-renderer.header';

export const codePropertyRegex = /^(html|css|ts|js)$/;

export function stripCustomPropertyPrefix(propertyName: string): string {
    return propertyName.replace(WIDGET_PROPERTY_PREFIX, '');
}

export function applyCustomPropertyPrefix(propertyName: string): string {
    if (propertyName.indexOf(WIDGET_PROPERTY_PREFIX) > -1) {
        return propertyName;
    }

    return `${WIDGET_PROPERTY_PREFIX}${propertyName}`;
}

export function hasWidgetReference(property: IElementProperty): boolean {
    return property.name === AssetReference.Widget;
}

export function isCustomProperty(property: IElementProperty): boolean {
    return property.name.indexOf(WIDGET_PROPERTY_PREFIX) > -1;
}

export function isWidgetCodeProperty(property: Partial<IElementProperty>): boolean {
    return property.name !== undefined && property.name.match(codePropertyRegex) !== null;
}

export function getIframeIdFromEvent(mouseEvent: MouseEvent): string | undefined {
    const currentTarget = mouseEvent.currentTarget;
    if (!currentTarget) {
        return;
    }
    if ((currentTarget as Document).defaultView) {
        return (currentTarget as Document).defaultView?.frameElement?.id;
    }
    return (currentTarget as HTMLElement)?.ownerDocument?.defaultView?.frameElement?.id;
}

export function translateOpenEventPosition(
    mouseEvent: MouseEvent,
    widgetInstance: IWidgetInstance | undefined
): { x: number; y: number } {
    if (!widgetInstance?.instance) {
        return {
            x: mouseEvent.clientX,
            y: mouseEvent.clientY
        };
    }

    const { x: widgetX, y: widgetY } = widgetInstance.instance;
    // mouseEvent.clientX and clientY values are relative to the iframe
    return {
        x: mouseEvent.clientX + widgetX,
        y: mouseEvent.clientY + widgetY
    };
}
